import React, { FC } from "react";
import Picture from "../components/common/Picture";
import { EnquiryForm } from "../components/common/EnquiryForm";

export const HeroImageSection: FC = () => {
    return (
        <div id="hero-section"
            className="snap-section relative h-56 sm:h-64 md:h-96 lg:h-[85vh] flex items-center bg-black justify-center text-center overflow-x-clip">
            <div className="absolute top-0 left-0 r-0 h-full w-full">
                <Picture
                    webpSrc="/images/restaurant_3.webp"
                    alt="Hero Image"
                    className="w-full h-full object-cover object-center"
                    onErrorSrc={'https://placehold.co/1920x1080/153D40/C6A375?text=All+Aces+Club'}
                />
            </div>
            <div
                className="absolute top-0 left-0 r-0 h-full w-full z-20 bg-gradient-to-b from-black to-transparent" />
            <div className="relative flex items-center justify-center h-full w-full z-20 bottom-10">
                <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-ivory text-opacity-90">
                    CONNECT
                </p>
            </div>
        </div>
    );
}

const ConnectPage = () => {
    return (
        <div className="bg-ivory text-royal-pine">
            <HeroImageSection />
            <section className="snap-section relative z-20 flex items-center justify-center md:h-auto lg:h-[calc(100vh-4rem)] mt-[-15vh] scroll-pb-16">
                <div className="container mx-auto px-4 ">
                    <div className="max-w-7xl relative mx-auto bg-white shadow-2xl">
                        <div className="hidden lg:block bg-royal-pine absolute right-0 top-0 h-full w-[25%]" />
                        <div className="flex flex-col lg:flex-row gap-8 py-8 sm:py-12 lg:py-16 px-4 sm:px-8 lg:px-12">
                            <EnquiryForm className="h-auto md:flex-1" />
                            <div className="h-60 sm:h-84 md:h-96 lg:h-auto lg:flex-1 lg:min-h-0 z-10">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4552.672115947758!2d77.3533889!3d28.3741389!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjjCsDIyJzI2LjkiTiA3N8KwMjEnMTIuMiJF!5e1!3m2!1sen!2sin!4v1760441936223!5m2!1sen!2sin"
                                    className="w-full h-full border-0"
                                    allowFullScreen={false}
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Location of All Aces Club in Ranchi"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="h-8" />
        </div>
    );
}

export default ConnectPage;